export default __webpack_public_path__ + "static/new-ely-scheda-tecnica-5cf0f6e275336b3cb953c713213e5447.pdf";